<template>
  <div :class="['codes-form-container']">
    <div class="txt" v-if="!userDidTry">
      TRY CRACKING THE CODES TO
      <br />UNLOCK Wilson’s Bunker
    </div>
    <div class="txt" v-else>
      SORRY!
      <br />TRY AGAIN TO CRACK THE CODES
    </div>
    <form @submit.prevent="handleSubmit" autocomplete="off">
      <p id="codeAWrapper" class="input-wrapper" :class="{error:aError}">
        <!-- <label for="codeA">Code 1 Required</label> -->
        <input
          id="codeA"
          v-model.trim="codeA"
          type="text"
          @input="handleChange"
          :class="{error:aError}"
          :placeholder="defaultText"
        />
      </p>
      <p id="codeBWrapper" class="input-wrapper" :class="{error:bError}">
        <!-- <label for="codeB">Code 2 Required</label> -->
        <input
          id="codeB"
          v-model.trim="codeB"
          type="text"
          @input="handleChange"
          :class="{error:bError}"
          :placeholder="defaultText"
        />
      </p>
      <p id="codeCWrapper" class="input-wrapper" :class="{error:cError}">
        <!-- <label for="codeC">Code 3 Required</label> -->
        <input
          id="codeC"
          v-model.trim="codeC"
          type="text"
          @input="handleChange"
          :class="{error:cError}"
          :placeholder="defaultText"
        />
      </p>
      <p>
        <button
          id="codesSubmitBtn"
          type="submit"
          value="Submit"
          :disabled="formIsComplete === false"
        >SUBMIT</button>
      </p>
    </form>
  </div>
</template>

<script>
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
import { ref } from "@vue/composition-api";
import { loadImage } from "@/composables/image-utils.js";
export default {
  name: "CodesForm",
  props: {},
  //   mixins: [validationMixin],
  setup(props, { emit }) {
    const codeA = new ref("");
    const codeB = new ref("");
    const codeC = new ref("");

    const aError = new ref(false);
    const bError = new ref(false);
    const cError = new ref(false);

    const defaultText = new ref("ENTER CODE");

    const answerA = process.env.VUE_APP_ANSWER_A;
    const answerB = process.env.VUE_APP_ANSWER_B;
    const answerC = process.env.VUE_APP_ANSWER_C;

    const formIsComplete = new ref(false);

    const userDidTry = new ref(false);

    const checkAnswers = () => {
      aError.value = codeA.value.toLowerCase() !== answerA.toLowerCase();
      bError.value = codeB.value.toLowerCase() !== answerB.toLowerCase();
      cError.value = codeC.value.toLowerCase() !== answerC.toLowerCase();

      const allAreCorrect = !aError.value && !bError.value && !cError.value;

      return allAreCorrect;
    };
    // map our code variables to their error variables
    const codeToError = (code) => {
      switch (code) {
        case codeA:
          return aError;
          break;
        case codeB:
          return bError;
          break;
        case codeC:
          return cError;
          break;

        default:
          return false;
          break;
      }
    };

    const setErrorByCode = (code, val) => {
      let error = codeToError(code);
      if (error) {
        error.value = val;
      }
    };

    // this version allows for an answer to be in any order,
    // we also detect if duplicate guesses are included
    const checkAnswers_v2 = () => {
      // console.log("-----------");
      const answers = [answerA, answerB, answerC].map((item) =>
        item.toLowerCase()
      );
      // console.log(answers);

      const userGuess = [codeA, codeB, codeC];

      let foundCodes = []; // cache if we found answer

      let result = true;

      userGuess.forEach((code) => {
        const val = code.value.toLowerCase();

        const alreadyFound = val in foundCodes;

        if (alreadyFound === false) {
          // we haven't found this one yet
          let found = answers.includes(val);
          // console.log(`found ${val} ${found}`);
          if (found) {
            foundCodes[val] = true; // set the flag so we can find duplicates

            setErrorByCode(code, false);
          } else {
            // console.log(`${val} guess not in answer`);
            setErrorByCode(code, true);
            result = false;
          }
        } else {
          // we already found it lets set error
          // console.log("we already found this one, set error");
          setErrorByCode(code, true);
          result = false;
        }
      });

      return result;
    };

    const checkValid = () => {};

    const handleSubmit = (event) => {
      //   console.log("handle Submit ", event);

      //   console.log(isARight, isBRight, isCRight);
      // console.log(`${aError.value} ${bError.value} ${cError.value}`);

      // const allAreCorrect = checkAnswers();
      const allAreCorrect = checkAnswers_v2();

      const trackingValue = allAreCorrect ? "codes_success" : "codes_fail";

      try {
        window.gtag("event", "code_submit", {
          event_category: "btn_click",
          event_label: trackingValue,
        });
      } catch (e) {
        // console.log(e);
      }

      if (allAreCorrect) {
        emit("complete");
      } else {
        // console.log("got some wrong");
        userDidTry.value = true;
      }
    };

    const handleChange = (event) => {
      const value = event.target.value;
      // console.log("handleChange ", event.target);
      // if we have previously had an error lets remove it when empty value
      if (value === "") {
        // console.log("lets reset the error");
        const id = event.target.id;
        switch (id) {
          case "codeA":
            aError.value = false;
            break;
          case "codeB":
            bError.value = false;
            break;
          case "codeC":
            cError.value = false;
            break;

          default:
            break;
        }
        // console.log(id);
      }

      formIsComplete.value = [codeA, codeB, codeC].every((item) => {
        return item.value.length > 0;
      });
    };

    // console.log(loadImage);
    // console.log(require("../assets/images/input_A_bg_error.png"));
    // hacky: preload error backgrounds for input values. had trouble using a sprite sheet with the background since the div containers are responsive
    [
      require("../assets/images/input_A_bg_error.png"),
      require("../assets/images/input_B_bg_error.png"),
      require("../assets/images/input_C_bg_error.png"),
    ].forEach((img) => {
      loadImage(img)
        .then((result) => {
          // console.log("finished preload");
        })
        .catch((error) => {
          // console.log(error);
        });
    });

    return {
      codeA,
      codeB,
      codeC,
      aError,
      bError,
      cError,
      defaultText,
      handleSubmit,
      handleChange,
      formIsComplete,
      userDidTry,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @import "~@/assets/css/main.css";
input.error {
  color: #f6deb7;
  text-decoration: line-through;
  // border: 2px solid red;
  // border-radius: 4px;
  // background-color: none;
}

//TODO: put some conditional styles in here for different sizes
.txt {
  font-size: 1.1rem;
  text-transform: uppercase;
}

input {
  font-size: 1.5rem;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  // background-repeat: no-repeat;
  // background-position: center center;
  // background-size: cover;
  border: none;
  // width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-align: center;
  line-height: 1.5;
  // caret-color: transparent;

  &:focus {
    outline: none;
  }
}

.input-wrapper {
  background-size: contain;
  background-position: center center;
  // background-size: 200%;
  background-repeat: no-repeat;
  overflow: hidden;
  // background-image: url("~@/assets/images/main.png");
  // display: inline-block;
}

#codeAWrapper {
  background-image: url("~@/assets/images/input_A_bg.png");
  // background-position: -1px -87px;
  // width: 598px;
  // height: 82px;
}

#codeAWrapper.error {
  background-image: url("~@/assets/images/input_A_bg_error.png");
}

#codeBWrapper.error {
  background-image: url("~@/assets/images/input_B_bg_error.png");
}

#codeCWrapper.error {
  background-image: url("~@/assets/images/input_C_bg_error.png");
}

#codeBWrapper {
  background-image: url("~@/assets/images/input_B_bg.png");
  // background-position: -1201px -1px;
  // width: 586px;
  // height: 83px;
}

#codeCWrapper {
  background-image: url("~@/assets/images/input_C_bg.png");
  // background-position: -1px -1px;
  // width: 598px;
  // height: 84px;
}

#codesSubmitBtn {
  background: transparent;
  background-image: url("~@/assets/images/submit_btn_bg.png");
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  border: none;
  color: white;
  width: 60%;
  padding: 5px;
  font-size: 1.1rem;

  transition: opacity 0.75s;
}

#codesSubmitBtn:disabled {
  opacity: 0.5;
}
</style>